module.exports = __webpack_public_path__ + "img/2.ad2b164c.jpg";